export const getDefaultOperationByType = dataType => {
	switch (dataType) {
		case 'date':
		case 'datetime':
		case 'datetimeOffset':
		case 'time':
			return '>=';
		case 'boolean':
		case 'number':
			return '=';
		case 'multiLanguage':
		case 'object':
		case 'string':
		default:
			return 'contains';
	}
};
